import { render, staticRenderFns } from "./IncreaseNumber.vue?vue&type=template&id=2efe9e8a&"
import script from "./IncreaseNumber.vue?vue&type=script&lang=js&"
export * from "./IncreaseNumber.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2efe9e8a')) {
      api.createRecord('2efe9e8a', component.options)
    } else {
      api.reload('2efe9e8a', component.options)
    }
    module.hot.accept("./IncreaseNumber.vue?vue&type=template&id=2efe9e8a&", function () {
      api.rerender('2efe9e8a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2C5LnIT3WcwM9/JS/comp/IncreaseNumber.vue"
export default component.exports